module.exports = __webpack_public_path__ + "static/media/text-icon.b274d94a.svg";